import React, { createContext, useContext, useState } from 'react';

type HVWorkPermitData = {
  department: string;
  priority: string;
  jobNumber: string;
  ewt: string;
  location: string;
  crossReference: string;
  unit: string;
  plantCode: string;
  apparatus: string;
  hazards: string;
};

const initialState: HVWorkPermitData = {
  department: '',
  priority: '',
  jobNumber: '',
  ewt: '',
  location: '',
  crossReference: '',
  unit: '',
  plantCode: '',
  apparatus: '',
  hazards: '',
};

const HVWorkPermitContext = createContext<any>(null);

export const HVWorkPermitProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [permitData, setPermitData] = useState<HVWorkPermitData>(initialState);

  const resetPermitData = () => setPermitData(initialState);

  return <HVWorkPermitContext.Provider value={{ permitData, setPermitData, resetPermitData }}>{children}</HVWorkPermitContext.Provider>;
};

export const useHVWorkPermit = () => useContext(HVWorkPermitContext);
